<script>
import { Pie } from "vue-chartjs";

export default {
  extends: Pie,
  props: {
    labels: {
      type: Array,
      default: null
    },
    colors: {
      type: Array,
      default: null
    },
    data: {
      type: Array,
      default: null
    }
  },
  data() {
    return {
      chartdata: {
        labels: this.labels,
        datasets: [
          {
            data: this.data,
            backgroundColor: this.colors
          }
        ]
      },
      options: {
        responsive: true
      }
    };
  },
  mounted() {
    this.renderChart(this.chartdata, this.options);
  }
};
</script>
